const Heart = ({ ...props }) => {
  return (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18.0592 1.44914C15.9303 -0.363373 12.7467 -0.062589 10.7701 1.97649L10.0006 2.77337L9.23104 1.9804C7.63727 0.331946 4.4224 -0.66025 1.9419 1.44914C-0.511244 3.54291 -0.640152 7.30076 1.55518 9.56641L9.11385 17.3712C9.35604 17.6212 9.67635 17.7501 9.99667 17.7501C10.317 17.7501 10.6373 17.6251 10.8795 17.3712L18.4382 9.56641C20.6413 7.30076 20.5124 3.54291 18.0592 1.44914ZM17.5475 8.69921L10.0162 16.504L2.45363 8.69921C0.953613 7.15232 0.64111 4.20307 2.75441 2.40228C4.89506 0.574136 7.41071 1.89837 8.33259 2.8515L10.0006 4.57417L11.6686 2.8515C12.5748 1.91399 15.1139 0.585855 17.2467 2.40228C19.3561 4.19917 19.0475 7.14841 17.5475 8.69921Z" fill="#464544"/>
    </svg>
  )
}

export default Heart
